import { EPunctualityStatus } from 'features/Trips/types'

export const TRIPS_LIMIT = 50

export const punctualityThresholds = {
  [EPunctualityStatus.EARLY]: 0,
  [EPunctualityStatus.ON_TIME]: 16,
  [EPunctualityStatus.MODERATE]: 21
}
